export default {"src":"/_next/static/image/public/images/ic_booking_animation.b39245c11e0f5e3af51abe5df2858289.gif","height":600,"width":600};